import type { ComponentType } from "react"

import { CoachLinkAccountsPage } from "@/3514/pages"
import Offboarding from "@/components/offboarding/Offboarding"
import Profile from "@/components/profile/Profile"
import PostJourneyRedirect from "@/components/redirect-post-journey/PostJourneyRedirect"
import WaitingListPage from "@/components/waiting-list/WaitingListPage"
import { CoachUrls, ParticipantUrls } from "@/constants"
import {
    AssignModulePage,
    CoachItineraryPage,
    CoachRatingPage,
    CoachWelcomePage,
    CoachingPlanPage,
    CoachingSessionsPage,
    ParticipantSwapSessionPage,
    SimulabChatPage,
    SimulabCoacheesPage,
    StakeholderSurveyPage,
    SurveysPage
} from "@/pages"
import CoachSettingsAvailabilityStepPage from "@/pages/coach-settings/AvailabilityStep"
import CoachSettingsCalendarAddStepPage from "@/pages/coach-settings/CalendarAdd"
import CoachSettingsConfirmAvailabilityStepPage from "@/pages/coach-settings/ConfirmAvailabilityStep"
import CoachSettingsLinkCalendarStepPage from "@/pages/coach-settings/LinkCalendarStep"
import { CoachCalendarStepUrls as CoachCalendarStep } from "@/pages/coach-settings/constants"

type Route = {
    path: string
    Component: ComponentType<any>
    order?: number
}

const participantRoutes: Route[] = [
    {
        path: ParticipantUrls.COACH_RATING,
        Component: CoachRatingPage
    },
    {
        path: ParticipantUrls.WAITING_LIST,
        Component: WaitingListPage
    },
    {
        path: ParticipantUrls.WAITING_LIST_SSO,
        Component: WaitingListPage
    },
    {
        path: ParticipantUrls.SESSION_LIST,
        Component: CoachingSessionsPage
    },
    {
        path: ParticipantUrls.SURVEYS,
        Component: SurveysPage
    },
    {
        path: ParticipantUrls.SWAP_SESSION,
        Component: ParticipantSwapSessionPage
    },
    {
        path: ParticipantUrls.OFFBOARDING,
        Component: Offboarding
    },
    {
        path: ParticipantUrls.PARTICIPANT_REDIRECT_URL_PAGE,
        Component: PostJourneyRedirect
    },
    {
        path: ParticipantUrls.PROFILE,
        Component: Profile
    },
    {
        path: ParticipantUrls.COACHING_PLAN,
        Component: CoachingPlanPage
    },
    {
        path: ParticipantUrls.COACHEES,
        Component: SimulabCoacheesPage
    },
    {
        path: ParticipantUrls.SIMULAB_CHAT,
        Component: SimulabChatPage
    },
    {
        path: ParticipantUrls.ASSIGN_MODULE,
        Component: AssignModulePage
    }
]

/**
 * @deprecared move to appropriate routes.ts files
 */
const coachCalendarSetupRoutes: Route[] = [
    {
        path: CoachCalendarStep.LINK_CALENDAR_STEP,
        Component: CoachSettingsLinkCalendarStepPage,
        order: 1
    },
    {
        path: CoachCalendarStep.LINK_ACCOUNTS_STEP,
        Component: CoachLinkAccountsPage,
        order: 2
    },
    {
        path: CoachCalendarStep.AVAILABILITY_STEP,
        Component: CoachSettingsAvailabilityStepPage,
        order: 3
    },
    {
        path: CoachCalendarStep.AVAILABILITY_CONFIRM_STEP,
        Component: CoachSettingsConfirmAvailabilityStepPage,
        order: 4
    }
]

const coachRoutes: Route[] = [
    {
        path: CoachUrls.WELCOME,
        Component: CoachWelcomePage
    },
    {
        path: CoachUrls.ITINERARY,
        Component: CoachItineraryPage
    },
    {
        path: CoachUrls.PARTICIPANT_COACHING_PLAN,
        Component: CoachingPlanPage
    },
    {
        path: CoachCalendarStep.CALENDAR_ADD,
        Component: CoachSettingsCalendarAddStepPage
    },
    ...coachCalendarSetupRoutes
]

const unauthorizedPages: Route[] = [
    {
        path: ParticipantUrls.SURVEY_BY_CODE,
        Component: StakeholderSurveyPage
    }
]

export { participantRoutes, coachRoutes, unauthorizedPages, coachCalendarSetupRoutes }
